import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter.boolean('active', 'Active'),
    filter
      .options.list('integration_data', 'TCPA Configuration', TCPA_CONFIGURATION_OPTIONS)
      .getValue(value => JSON.stringify(value))
      .setValue(value => JSON.parse(value)),
  ], [])
}

const TCPA_CONFIGURATION_OPTIONS = [
  { label: 'True', value: '{"$and":[{"$like":"%pid%"},{"$like":"%sid%"},{"$like":"%twyurl%"}]}' },
  { label: 'False', value: '{"$and":[{"$notLike":"%pid%"},{"$notLike":"%sid%"},{"$notLike":"%twyurl%"}]}' },
]
